(function () {
  const drawer = document.getElementById('TwCartDrawer');
  const itemsContainer = document.getElementById('TwCartDrawerItems');
  const subtotalEl = document.getElementById('TwCartDrawerSubtotal');
  const emptyEl = document.getElementById('TwCartDrawerEmpty');
  const footerEl = drawer?.querySelector('.tw-cart-drawer__footer');
  const shippingRowEl = document.getElementById('TwCartDrawerShippingRow');
  const promoProductsEl = document.getElementById('TwCartDrawerPromoProducts');

  const offerProgressEl = document.getElementById('TwCartDrawerOfferProgress');
  const offerProgressMessageEl = document.getElementById('TwCartDrawerOfferProgressMessage');
  const offerStepOneEl = document.getElementById('TwCartDrawerOfferStepOne');
  const offerStepTwoEl = document.getElementById('TwCartDrawerOfferStepTwo');

  const isCartPage = window.location.pathname === '/cart';

  const shippingEl = document.getElementById('TwCartDrawerShipping');
  const shippingTextEl = document.getElementById('TwCartDrawerShippingText');
  const shippingFillEl = document.getElementById('TwCartDrawerShippingFill');

  if (!drawer) return;

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(cents / 100);
  }

  function stripRichText(html) {
    if (!html) return '';

    return html
      .replace(/<\/?p[^>]*>/g, '')
      .replace(/\n/g, '')
      .trim();
  }

  function isIneligibleOfferItem(item) {
    const fieldsToCheck = [
      item.product_title,
      item.variant_title,
      item.handle,
      item.product_type
    ];

    const text = fieldsToCheck
      .map((field) => String(field || '').toLowerCase())
      .join(' ');

    return (
      text.includes('bundle') ||
      text.includes('3 month') ||
      text.includes('3-month') ||
      text.includes('3 course') ||
      text.includes('3-course') ||
      text.includes('three month') ||
      text.includes('three-month') ||
      text.includes('three course') ||
      text.includes('three-course')
    );
  }

const kiteOfferCampaignRules = {
  immunitybogof: [
    'probiotics-for-immune-system'
  ],
  vaginalmicrobiomebogof: [
    'probiotics-for-vaginal-microbiome'
  ],
  fullrange: [
    'probiotics-for-immune-system',
    'probiotics-for-antibiotics-use',
    'probiotics-for-fussy-babies',
    'probiotics-for-vaginal-microbiome'
  ]
};

function getCurrentKiteCampaign() {
  return String(sessionStorage.getItem('ss_kite_campaign_name') || '')
    .toLowerCase()
    .trim();
}

function isEligibleOfferItem(item) {
  const handle = String(item.handle || '').toLowerCase().trim();
  const currentCampaign = getCurrentKiteCampaign();

  const eligibleHandlesForCampaign =
    kiteOfferCampaignRules[currentCampaign] || [];

  return eligibleHandlesForCampaign.includes(handle);
}

  function getOfferState(cart) {
    const items = cart.items || [];

    const eligiblePaidQty = items
      .filter((item) => isEligibleOfferItem(item) && !isIneligibleOfferItem(item) && item.final_line_price > 0)
      .reduce((total, item) => total + Number(item.quantity || 0), 0);

    const freeQty = items
      .filter((item) => item.final_line_price === 0 && !isIneligibleOfferItem(item))
      .reduce((total, item) => total + Number(item.quantity || 0), 0);

    const hasAnyEligibleItem = items.some((item) =>
      isEligibleOfferItem(item) && !isIneligibleOfferItem(item)
    );

    const maxFreeItems = 2;

    return {
      eligiblePaidQty,
      freeQty,
      hasFreeItem: freeQty > 0,
      hasEligibleItem: hasAnyEligibleItem,
      canAddFreeItem: eligiblePaidQty > freeQty && freeQty < maxFreeItems
    };
  }

  function renderOfferProgress(cart) {
    if (!offerProgressEl || !offerProgressMessageEl) return;

    const isEmpty = !cart.items || cart.items.length === 0;

    // console.log(
    //   cart.items.map(item => ({
    //     title: item.product_title,
    //     qty: item.quantity,
    //     properties: item.properties,
    //     final_price: item.final_line_price
    //   }))
    // );

    const offerState = getOfferState(cart);

    if (isEmpty || !offerState.hasEligibleItem) {
      offerProgressEl.hidden = true;
      return;
    }

    offerProgressEl.hidden = false;

    // 🔁 Always reset visibility
    offerProgressMessageEl.style.display = '';

    if (offerStepOneEl) {
      offerStepOneEl.classList.toggle('is-complete', offerState.freeQty >= 1);
    }

    if (offerStepTwoEl) {
      offerStepTwoEl.classList.toggle('is-complete', offerState.freeQty >= 2);
    }

    if (offerState.eligiblePaidQty === 1 && offerState.freeQty === 0) {
      offerProgressMessageEl.textContent = 'Add one more item to unlock your first free product.';
      return;
    }

    if (offerState.eligiblePaidQty === 1 && offerState.freeQty === 1) {
      offerProgressMessageEl.textContent = 'You’ve unlocked 1 free item. Add another full-price item to start unlocking your second free product.';
      return;
    }

    if (offerState.eligiblePaidQty >= 2 && offerState.freeQty === 1) {
      offerProgressMessageEl.textContent = 'You’re eligible for one more free item. Add another product to complete your second Buy 1 Get 1 Free offer.';
      return;
    }

    // ✅ Hide message when fully complete
    if (offerState.eligiblePaidQty >= 2 && offerState.freeQty >= 2) {
      offerProgressMessageEl.style.display = 'none';
      return;
    }

    offerProgressMessageEl.textContent = 'Add eligible products to unlock up to 2 free items in this order.';
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function setLoading(isLoading) {
    drawer.classList.toggle('is-loading', isLoading);
  }

  function setEmptyState(isEmpty) {
    drawer.classList.toggle('is-empty', isEmpty);

    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (footerEl) footerEl.hidden = isEmpty;
  }

  function renderPromoProducts(cart) {
  if (!promoProductsEl) return;

  const currentCampaign = String(sessionStorage.getItem('ss_kite_campaign_name') || '')
    .toLowerCase()
    .trim();

  const excludedCarouselCampaigns = [
    'immunitybogof',
    'vaginalmicrobiomebogof'
  ];

  const isExcludedCampaign = excludedCarouselCampaigns.includes(currentCampaign);

  const hasItems = cart.items && cart.items.length > 0;
  const offerState = getOfferState(cart);

  promoProductsEl.hidden =
    isExcludedCampaign ||
    !hasItems ||
    !offerState.canAddFreeItem ||
    !offerState.hasEligibleItem;
}

  function renderSavings(cart) {
    if (!footerEl) return;

    let savingsRow = document.getElementById('TwCartDrawerSavingsRow');
    const subtotalRow = footerEl.querySelector('.tw-cart-drawer__subtotal');

    const totalSavings = cart.total_discount || 0;

    if (!totalSavings || totalSavings <= 0) {
      if (savingsRow) savingsRow.remove();
      return;
    }

    if (!savingsRow) {
      savingsRow = document.createElement('div');
      savingsRow.id = 'TwCartDrawerSavingsRow';
      savingsRow.className = 'tw-cart-drawer__shipping-row';
      savingsRow.style.color = '#0966ad';

      if (subtotalRow) {
        footerEl.insertBefore(savingsRow, subtotalRow);
      } else {
        footerEl.prepend(savingsRow);
      }
    }

    savingsRow.innerHTML = `
      <span>Savings</span>
      <strong>${formatMoney(totalSavings)}</strong>
    `;
  }

  function renderFreeShipping(cart) {
  if (!shippingEl || !shippingTextEl || !shippingFillEl) return;

  const threshold = Number(shippingEl.dataset.threshold);
  const items = cart.items || [];

  const hasSubscription = items.some((item) =>
    Boolean(item.selling_plan_allocation)
  );

  const hasPaidOneTimeItem = items.some((item) => {
    const isSubscription = Boolean(item.selling_plan_allocation);
    const hasPaidValue = Number(item.final_line_price || 0) > 0;

    return !isSubscription && hasPaidValue;
  });

  const hasSubscriptionAndOnlyFreeExtras =
    hasSubscription && !hasPaidOneTimeItem;

  /*
   * Subscription plus free promotional items only.
   * The free gift does not trigger the standard shipping threshold.
   */
  if (hasSubscriptionAndOnlyFreeExtras) {
    shippingEl.style.display = 'block';
    shippingEl.classList.add('is-complete');

    shippingFillEl.style.width = '100%';

    shippingTextEl.innerHTML = `
      <strong>Your subscription order ships FREE</strong>
    `;

    if (shippingRowEl) {
      shippingRowEl.hidden = false;
      shippingRowEl.innerHTML = `
        <span>Shipping</span>
        <strong>FREE</strong>
      `;
    }

    return;
  }

  if (!threshold || threshold <= 0) {
    shippingEl.style.display = 'none';

    if (shippingRowEl) {
      shippingRowEl.hidden = true;
    }

    return;
  }

  const total = Number(cart.total_price || 0);
  const remaining = Math.max(0, threshold - total);
  const percentage = Math.min(100, (total / threshold) * 100);

  /*
   * The complete paid cart has reached the normal
   * free-shipping threshold.
   */
  if (remaining <= 0) {
    shippingEl.style.display = 'none';

    if (shippingRowEl) {
      shippingRowEl.hidden = false;
      shippingRowEl.innerHTML = `
        <span>Shipping</span>
        <strong>FREE</strong>
      `;
    }

    return;
  }

  shippingEl.style.display = 'block';
  shippingEl.classList.remove('is-complete');
  shippingFillEl.style.width = `${percentage}%`;

  if (shippingRowEl) {
    shippingRowEl.hidden = true;
  }

  /*
   * There is a subscription plus at least one paid
   * non-subscription item.
   */
  if (hasSubscription && hasPaidOneTimeItem) {
    shippingTextEl.innerHTML = `
      <strong>Your subscription ships FREE</strong><br>
      Add <strong>${formatMoney(remaining)}</strong> more for free delivery on your full order
    `;

    return;
  }

  /*
   * Standard one-time-purchase cart.
   */
  shippingTextEl.innerHTML = `
    You are <strong>${formatMoney(remaining)}</strong> away from FREE SHIPPING
  `;
}

  function renderCart(cart) {
    if (!itemsContainer || !subtotalEl) return;

    const isEmpty = !cart.items || cart.items.length === 0;
    const offerState = getOfferState(cart);

    subtotalEl.textContent = formatMoney(cart.total_price);
    renderFreeShipping(cart);
    renderSavings(cart);
    renderPromoProducts(cart);
    renderOfferProgress(cart);
    setEmptyState(isEmpty);

    if (isEmpty) {
      itemsContainer.innerHTML = '';

      if (shippingRowEl) shippingRowEl.hidden = true;
      if (promoProductsEl) promoProductsEl.hidden = true;
      if (offerProgressEl) offerProgressEl.hidden = true;

      renderSavings({ total_discount: 0 });
      return;
    }

    function getDeliveryFrequencyLabel(item) {
      const sellingPlanName =
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan &&
        item.selling_plan_allocation.selling_plan.name
          ? item.selling_plan_allocation.selling_plan.name.toLowerCase()
          : '';

      if (sellingPlanName.includes('3') || sellingPlanName.includes('three')) {
        return 'Delivery every 90 days';
      }

      if (sellingPlanName.includes('1') || sellingPlanName.includes('one')) {
        return 'Delivery every 30 days';
      }

      return 'Subscription delivery';
    }

function getPurchaseTypeHtml(item) {
  const hasSellingPlan = item.selling_plan_allocation;
  const isFree = Number(item.final_line_price || 0) === 0;

  const themeColour =
    item.properties && item.properties._theme_colour
      ? item.properties._theme_colour
      : 'd-green';

  const themeClass = `text-brand-${themeColour}`;

if (isFree) {
  return `
    <p class="tw-cart-drawer-item__purchase-type is-free-gift ${themeClass}">
      One-time free gift · No subscription
    </p>
  `;
}

  if (hasSellingPlan) {
    return `
      <p class="tw-cart-drawer-item__purchase-type is-subscription ${themeClass}">
        ${getDeliveryFrequencyLabel(item)}
      </p>
    `;
  }

  return `
    <p class="tw-cart-drawer-item__purchase-type is-onetime">
      One-time purchase
    </p>
  `;
}

    itemsContainer.innerHTML = cart.items.map((item, index) => {
      const line = index + 1;

      const image = item.image
        ? `<img src="${item.image}" alt="${item.product_title}" class="tw-cart-drawer-item__image">`
        : '';

      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="tw-cart-drawer-item__variant">${item.variant_title}</p>`
        : '';

      const priceDisplay = item.final_line_price === 0
        ? 'FREE'
        : formatMoney(item.final_line_price);

      const doubleUpButton = !offerState.hasFreeItem && isEligibleOfferItem(item) && !isIneligibleOfferItem(item)
        ? `
          <button
            type="button"
            class="tw-cart-drawer-item__double-up"
            data-cart-double-up
            data-variant-id="${item.variant_id}"
          >
            &plus; Add another for free
          </button>
        `
        : '';

      return `
        <div class="tw-cart-drawer-item" data-cart-line="${line}">
          <div class="tw-cart-drawer-item__media">
            ${image}
          </div>

          <div class="tw-cart-drawer-item__content">
            <div class="tw-cart-drawer-item__top">
              <p class="tw-cart-drawer-item__title">${item.product_title}</p>

              <button
                type="button"
                class="tw-cart-drawer-item__remove"
                data-cart-remove
                data-line="${line}"
                aria-label="Remove ${item.product_title}"
              >
                ×
              </button>
            </div>

            ${variantTitle}
            ${getPurchaseTypeHtml(item)}

            <div class="tw-cart-drawer-item__bottom">
              <div class="tw-cart-drawer-qty">
                <button
                  type="button"
                  class="tw-cart-drawer-qty__button"
                  data-cart-qty-minus
                  data-line="${line}"
                  data-quantity="${item.quantity}"
                  aria-label="Decrease quantity"
                >
                  −
                </button>

                <span class="tw-cart-drawer-qty__value">${item.quantity}</span>

                <button
                  type="button"
                  class="tw-cart-drawer-qty__button"
                  data-cart-qty-plus
                  data-line="${line}"
                  data-quantity="${item.quantity}"
                  aria-label="Increase quantity"
                >
                  +
                </button>
              </div>

              <strong class="tw-cart-drawer-item__price">
                ${priceDisplay}
              </strong>
            </div>

            ${doubleUpButton}
          </div>
        </div>
      `;
    }).join('');
  }

  function updateEmptyProductVariant(select) {
    const productCard = select.closest('.tw-cart-drawer-empty-product');
    if (!productCard) return;

    const selectedOption = select.options ? select.options[select.selectedIndex] : null;
    const addButton = productCard.querySelector('[data-cart-drawer-add]');
    const priceEl = productCard.querySelector('[data-cart-drawer-product-price]');

    if (addButton) {
      addButton.dataset.variantId = select.value;
      addButton.disabled = selectedOption ? selectedOption.disabled : false;
      addButton.textContent = selectedOption && selectedOption.disabled ? 'Sold out' : 'Add';
    }

    if (priceEl && selectedOption && selectedOption.dataset.price) {
      priceEl.textContent = selectedOption.dataset.price;
    }
  }

  async function refreshCart() {
    if (window.theoremCart && typeof window.theoremCart.getCart === 'function') {
      const cart = await window.theoremCart.getCart();
      renderCart(cart);
      return cart;
    }

    const response = await fetch('/cart.js');
    const cart = await response.json();

    renderCart(cart);

    return cart;
  }

  async function changeLineQuantity(line, quantity) {
    if (!window.theoremCart) return;

    setLoading(true);

    try {
      await window.theoremCart.changeItem({
        line: Number(line),
        quantity: Number(quantity)
      });

      await refreshCart();
    } catch (error) {
      console.error('Cart drawer update error:', error);
    } finally {
      setLoading(false);
    }
  }

  async function addVariantToCart(variantId, button) {
    if (!window.theoremCart || !variantId) return;

    setLoading(true);

    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding...';
    }

    try {
      await window.theoremCart.addItem({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      });

      await refreshCart();
    } catch (error) {
      console.error('Add from cart drawer error:', error);
    } finally {
      setLoading(false);

      if (button) {
        button.disabled = false;
        button.textContent = button.dataset.originalText || 'Add';
      }
    }
  }

  function bindCartIcon() {
    const cartTriggers = document.querySelectorAll('[data-cart-drawer-trigger]');

    cartTriggers.forEach((trigger) => {
      trigger.addEventListener('click', async function (event) {
        event.preventDefault();

        setLoading(true);

        try {
          const cart = await refreshCart();
          renderCart(cart);
          openDrawer();
        } catch (error) {
          console.error('Cart drawer open error:', error);
          window.location.href = trigger.getAttribute('href') || '/cart';
        } finally {
          setLoading(false);
        }
      });
    });
  }

  document.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  itemsContainer?.addEventListener('click', function (event) {
    const minusButton = event.target.closest('[data-cart-qty-minus]');
    const plusButton = event.target.closest('[data-cart-qty-plus]');
    const removeButton = event.target.closest('[data-cart-remove]');
    const doubleUpButton = event.target.closest('[data-cart-double-up]');

    if (minusButton) {
      const line = minusButton.dataset.line;
      const currentQuantity = Number(minusButton.dataset.quantity);
      const newQuantity = Math.max(currentQuantity - 1, 0);

      changeLineQuantity(line, newQuantity);
    }

    if (plusButton) {
      const line = plusButton.dataset.line;
      const currentQuantity = Number(plusButton.dataset.quantity);
      const newQuantity = currentQuantity + 1;

      changeLineQuantity(line, newQuantity);
    }

    if (removeButton) {
      const line = removeButton.dataset.line;

      changeLineQuantity(line, 0);
    }

    if (doubleUpButton) {
      const variantId = doubleUpButton.dataset.variantId;
      addVariantToCart(variantId, doubleUpButton);
    }
  });

  document.addEventListener('change', function (event) {
    const variantSelect = event.target.closest('[data-cart-drawer-variant-select]');
    if (!variantSelect) return;

    updateEmptyProductVariant(variantSelect);
  });

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest('[data-cart-drawer-add]');
    if (!addButton) return;

    const variantSelect = addButton
      .closest('.tw-cart-drawer-empty-product')
      ?.querySelector('[data-cart-drawer-variant-select]');

    const variantId = variantSelect ? variantSelect.value : addButton.dataset.variantId;

    addVariantToCart(variantId, addButton);
  });

  document.addEventListener('click', function (event) {
    const prevButton = event.target.closest('[data-promo-carousel-prev]');
    const nextButton = event.target.closest('[data-promo-carousel-next]');

    if (!prevButton && !nextButton) return;

    const carousel = document.querySelector('[data-promo-carousel]');
    if (!carousel) return;

    const scrollAmount = 292;

    carousel.scrollBy({
      left: nextButton ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  });

  document.addEventListener('cartUpdated', function (event) {
    const cart = event.detail && event.detail.newCart;

    if (!cart) return;

    renderCart(cart);

    if (!isCartPage) {
      openDrawer();
    }
  });

  document.addEventListener('click', function (event) {
    const toggleButton = event.target.closest('[data-promo-products-toggle]');
    if (!toggleButton) return;

    const promoSection = toggleButton.closest('.tw-cart-drawer-promo-products');
    if (!promoSection) return;

    const isCollapsed = promoSection.classList.toggle('is-collapsed');

    toggleButton.setAttribute('aria-expanded', String(!isCollapsed));
  });

  bindCartIcon();

  window.twCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    render: renderCart,
    refresh: refreshCart
  };
})();